<template>
  <div class="category-slider">
    <div
      class="category-slider__wrap"
      ref="sliderContainer"
      @mouseup="handleMouseUp"
      @mousedown="handleMouseDown"
      @mouseleave="handleMouseUp"
      @mousemove="handleMouseMove"
    >
      <div class="category-slider__list" :style="{ transform: `translateX(${currentTranslateX}px)` }">
        <div
          class="category-slider__item"
          :class="`category-slider__item--${item.backgroundClass}`"
          v-for="item in items"
          :key="item.id"
          @click="emit('clickCategory', item.identity)"
        >
          <atomic-image
            v-if="item.iconTab"
            class="category-slider__item-icon"
            :src="`${gamehubCdn}/icons/categories/${item.iconTab}.png`"
            :width="28"
            :height="28"
          />

          {{ item.label }}
        </div>
      </div>
    </div>

    <div v-show="showLeftArrow" class="category-slider__arrow category-slider__arrow--left" @click="scrollLeft">
      <atomic-icon id="back" />
    </div>

    <div v-show="showRightArrow" class="category-slider__arrow category-slider__arrow--right" @click="scrollRight">
      <atomic-icon id="back" />
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { ICollection } from '~/skeleton/core/types';

  defineProps<{
    items?: ICollection[];
    activeCollection?: ICollection;
  }>();

  const emit = defineEmits(['clickCategory']);

  const {
    public: { gamehubCdn },
  } = useRuntimeConfig();

  const sliderContainer = ref(null);

  const { currentTranslateX, maxTranslateX, handleMouseDown, handleMouseMove, handleMouseUp, isMoved } = useSlider({
    sliderContainer,
  });

  const showLeftArrow = computed(() => currentTranslateX.value < 0);
  const showRightArrow = computed(() => currentTranslateX.value > maxTranslateX.value);

  const scrollLeft = () => {
    currentTranslateX.value = 0;
  };

  const scrollRight = () => {
    currentTranslateX.value = maxTranslateX.value;
  };

  watch(isMoved, newValue => {
    if (newValue) {
      setTimeout(() => {
        isMoved.value = false;
      }, 0);
    }
  });
</script>

<style src="~/assets/styles/components/slider/nav/cat.scss" lang="scss" />
